import { render, staticRenderFns } from "./NotificationExpansionPanel.vue?vue&type=template&id=56ff0846&scoped=true&"
import script from "./NotificationExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationExpansionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ff0846",
  null
  
)

export default component.exports